<template>
  <PageWithLayout>
    <div class="section_result">
      <div class="section_body">
        <span class="icon_result_gray"><span class="ico_brand ico_exclam_error"></span></span>
        <h2 class="tit_section" v-html="messages[code]">
        </h2>
        <p class="desc_section" v-html="subMessages[code]"></p>
      </div>
      <div class="section_foot">
        <button class="btn_white" @click="goHome">{{'홈으로'}}</button>
<!--        // 사용자에 의한 서비스 신청 제거-->
<!--        <button class="btn_white" @click="goHome">{{$route.params.code !== '3160' ? '홈으로' : '서비스 재신청'}}</button>-->
      </div>
    </div>
  </PageWithLayout>
</template>
<script>
import PageWithLayout from '@/components/layout/PageWithLayout';
import SessionStorageService from "../../../plugins/SessionStorageService";
import routerPath from "../../../router/routerPath";

const sessionStorageService = SessionStorageService.getService();

export default {
  name: 'RegisterFail',
  components: {
    PageWithLayout,
  },
  data() {
    return {
      code: null,
      
      messages: {
        3030: "서비스에 가입되어있지 않은 회원입니다. ",
        3040: "서비스 승인이 진행 중 입니다.",
        3070: "서비스 요금 미 결제로 서비스 이용의 제약이 있습니다.",
        3080: "서비스 이용이 제약이 있습니다.",
        3110: "서비스 이용 정지 상태로 이용이 불가합니다.",
        3160: "서비스가 해지되었습니다.",
        3170: "서비스 승인이 반려되었습니다.",
        5110: "이미 가입된 회원입니다.",
        5120: "결재 서버와 연결에 실패하였습니다.",
        5000: "서비스 신청이 실패하였습니다. 다시 신청해주세요.",
        5130: "결재가 실패하였습니다.",
        
        // FAIL_3030
        // FAIL_3040
        // FAIL_3070
        // FAIL_3080
        // FAIL_3110
        // FAIL_3160
        // FAIL_3170
        // FAIL_5110
      },
      subMessages: {
        3030: "서비스 가입 신청 후 이용하실 수 있습니다.",
        3040: "승인 완료 시 서비스 이용이 가능하며, 가입 승인여부는 카카오톡으로 안내드립니다.",
        3070: "결제 후 다시 서비스를 정상적으로 이용하실 수 있습니다.",
        3080: "서비스 이용 미 결제로 설비스 이용의 제약이 있습니다. 마스터 관리자에게 요청하세요.",
        3110: "",
        3160: "",
        3170: "",
        5110: "",
        5120: "",
        5000: "",  
        5130: "",
         
      }

    }
  },
  beforeMount() {
    const {code} = this.$route.params;
    if(!code) {
      this.$router.push(this.$routerPath.INTRODUCE);
      return;
    }
    this.code = code;
  },
  methods: {
    goHome() {
      // if(this.$route.params.code === '3160') {
      //   const randomKey = sessionStorageService.getRandomKey();
      //   const appUserId = sessionStorageService.getUserId();
      //   if(!randomKey) {
      //     alert('randomKey 없음!');
      //     return;
      //   }
      //   if(!appUserId) {
      //     alert('appUserId 없음!');
      //     return;
      //   }
      //   this.$router.push({path:routerPath.JOIN, query:{code:'3030', appUserId, randomKey}})
      // } else {
        this.$router.push(this.$routerPath.INTRODUCE);
      // }
    }
  }
}
</script>
